import React from "react";
import "./detail.css";
import logo from "../../images/white-logo.png";
import Navbar from "../../components/navbar/Navbar";
import imgbanner from "../../images/banner6.png";
import Rightside from "../../components/rightside/Rightside";
import Banner from "../../components/banner/Banner";
import image from "../../images/banner7.png";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";
import { BsBookmark } from "react-icons/bs";
import { BsShareFill } from "react-icons/bs";
import Footer from "../../components/footer/Footer";
import FooterMob from "../../components/footer/FooterMob";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import parse from 'html-react-parser';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import axios from "axios";
import { useParams } from "react-router-dom";
import { baseLocal } from "../../context/BaseUrl";
import MobNav from "../../components/Mobnav/MobNav";
const logoM = require("../../images/sidebarlogo.png");

const Detail = () => {
  const { id } = useParams();

  const [Data, setData] = useState(null);
  const [toggleOneModal, setToggleOneModal] = useState(false);
  const [toggleTwoModal, setToggleTwoModal] = useState(false);

  const [application, setApplication] = useState({
    name: "",
    email: "",
    number: "",
    resume: "",
    description: "",
  });

  async function fetchData() {
    try {
      const response = await axios.get(
        `${baseLocal}/user/vacancy/getvacancy/${id}`
      );
      setData(response.data);
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, [id]);

  const SaveVacancy = async (value) => {
    try {
      const val = localStorage.getItem("user");

      if (!val) {
        toast.error("You are not logged in!!");

        return;
      }
      const user = JSON.parse(val);
      const token = user.token;

      const data = {
        vacancy_id: value,
        user_id: user.user._id,
      };
      const response = await fetch(
        `${baseLocal}/user/user_rights/postvacancy/${id}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      const result = await response.json();
      //   alert(result);
      if (result) {
        if (result.error == 500) {
          toast.error(result.msg);
        }
        toast.success(result.msg);

        fetchData();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const ApplyJob = async (vac_id) => {
    // try {
    const data = {
      ...application,
      vacancy_id: Data._id,
      institute_id: Data.institute_id
    };
    const response = await fetch(`${baseLocal}/user/job_form/post_job_form`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (result.code == 500) {
      toast.error(result.msg);
      return;
    }
    toast.success(result.msg);

    setApplication({
      name: "",
      email: "",
      number: "",
      resume: "",
      description: "",
    });

    setToggleTwoModal(!toggleTwoModal)
  };

  return (
    Data !== null && (
      <>
        <ToastContainer />
        <div className="home-background">
          <Navbar logoimg={logo} />
        </div>
        <MobNav />
        <div className="detail-page container-fluid pt-md-5 pt-0">
          <div className="row">
            <div className="col-lg-8 col-md-7 col-sm-12 col-xs-12">
              <div className="leftside">
                <div className="d-none d-md-block">
                <div className="profile">
                  <Banner bannerimg={Data.institute.banner} altimg={imgbanner} />
                  <img src={Data.institute.logo} alt="logo" className="logo notr" />
                </div>
                <div className="heading d-flex">
                  <div className="left">
                    <h4>{Data.name}</h4>
                    <p>{parse(Data.company)}</p>
                    <span>
                      <i className="fa-solid fa-location-dot"></i>{" "}
                      {Data.location}
                    </span>
                    <span className="green">
                      {Data.posted === 0 ? "Today" : `${Data.posted} Day Ago`}
                    </span>
                  </div>
                  <div className="right">
                    <h6 onClick={() => SaveVacancy(Data._id)}>
                      <BsBookmark className="pointer" />
                      {/* <BsShareFill className='ms-3 pointer' /> */}
                    </h6>
                    <button
                      onClick={() => {
                        setToggleOneModal(!toggleOneModal);
                        setTimeout(() => {
                          setToggleTwoModal(!toggleTwoModal);
                        }, 400);
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
                </div>
                <div className="d-flex d-md-none">
                <div className="profile">
                  <Banner bannerimg={Data.company_banner} altimg={imgbanner} />
                  <img src={Data.company_banner} alt="logo" className="logo notr" />
                </div>
                <div className="heading d-flex w-100">
                  <div className="left px-2 mt-1">
                    <h4>{Data.name}</h4>
                    <p>{parse(Data.company)}</p>
                    <span>
                      <i className="fa-solid fa-location-dot"></i>{" "}
                      {Data.location}
                    </span>
                    <span className="green">
                      {Data.posted === 0 ? "Today" : `${Data.posted} Day Ago`}
                    </span>
                  </div>
                  <div className="ms-auto right">
                    <h6 onClick={() => SaveVacancy(Data._id)}>
                      <BsBookmark className="pointer" />
                      {/* <BsShareFill className='ms-3 pointer' /> */}
                    </h6>
                  </div>
                </div>
                </div>
                <div className="d-flex d-md-none"><div className="heading d-flex w-100 ">
                  <div className="right w-100">
                    <button className="w-100 mt-2"
                      onClick={() => {
                        setToggleOneModal(!toggleOneModal);
                        setTimeout(() => {
                          setToggleTwoModal(!toggleTwoModal);
                        }, 400);
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div></div>
                <h5>About the Job</h5>
                <p>{parse(Data.about_job)}</p>
                <h5>Responsilibites</h5>
                <p>{parse(Data.responsibilities)}</p>
                <h5>Skills :-</h5>
                <p>{parse(Data.skills)}</p>
                <div className="about">
                  <h5>About Company</h5>
                  {Data.institute.banner ? (
                    <img
                      src={Data.institute.banner}
                      alt="img"
                      className="w-100"
                      height="200px"
                    />
                  ) : (
                    ""
                  )}
                  <p>{parse(Data.about)}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
              <div className="rigthside">
                <Rightside />
              </div>
            </div>
          </div>
        </div>

        {/* Quick Apply popup start */}
        <MDBModal
          show={toggleTwoModal}
          setShow={setToggleTwoModal}
          tabIndex="-1"
          className="apply-popup"
        >
          <MDBModalDialog centered>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Quick Apply</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => setToggleTwoModal(!toggleTwoModal)}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <Form>
                  <Form.Group className="mb-3" controlId="FormInput">
                    <Form.Control
                      type="text"
                      onInput={(e) =>
                        setApplication({ ...application, name: e.target.value })
                      }
                      value={application.name}
                      placeholder="Full name"
                      autoFocus
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="FormInput">
                    <Form.Control
                      type="email"
                      onInput={(e) =>
                        setApplication({
                          ...application,
                          email: e.target.value,
                        })
                      }
                      value={application.email}
                      placeholder="Email ID"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="FormInput">
                    <Form.Control
                      type="text"
                      onInput={(e) =>
                        setApplication({
                          ...application,
                          number: e.target.value,
                        })
                      }
                      value={application.number}
                      placeholder="Phone Number"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="FormInput">
                    <Form.Control
                      type="file"
                      onInput={(e) =>
                        setApplication({
                          ...application,
                          resume: e.target.value,
                        })
                      }
                      value={application.resume}
                      placeholder="Resume"
                      autoFocus
                    />
                  </Form.Group>
                  {/* <Form.Group className="mb-3" controlId="FormInput">
                    <Form.Control
                      type="text"
                      onInput={(e) =>
                        setApplication({
                          ...application,
                          description: e.target.value,
                        })
                      }
                      value={application.description}
                      placeholder="Post what you applying for ?"
                    />
                    </Form.Group>*/}
                  <Form.Group className="mb-3" controlId="FormTextarea">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      onInput={(e) =>
                        setApplication({
                          ...application,
                          description: e.target.value,
                        })
                      }
                      value={application.description}
                      placeholder="Send Message"
                    />
                  </Form.Group>
                </Form>

                <MDBBtn onClick={ApplyJob}>Apply Job</MDBBtn>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

        <Footer />
        <FooterMob />
      </>
    )
  );
};

export default Detail;
